module.exports = __webpack_public_path__ + "img/63c2f127f5816f47029d385356bd9322.gif";